/** Static copy for Help & Support → About section. */
export const HELP_ABOUT = {
  title: 'What are we',
  body:
    'Shingami is a multi-user trading automation platform that connects Discord trade signals to your brokerage account. Members of trading communities receive structured signals in Discord, review each trade, and approve or reject before anything is sent to the broker.',
  visionTitle: 'Vision',
  visionBody:
    'Make disciplined, community-driven trading accessible to everyone—without giving up control.',
  visionDetail:
    'We envision a world where traders in challenge programs and signal communities can act on opportunities in seconds, with their own account, their own rules, and full transparency at every step. Automation should amplify judgment, not replace it.',
};
